import * as React from "react";

import { Apps28Filled, Apps28Regular } from "@fluentui/react-icons";

import { TeamAppConfig } from "Apps/TeamAppModel";

const KevlarApp = React.lazy(async () => {
    const namedExport = await import("./KevlarApp");
    return { default: namedExport.KevlarApp };
});

export const Kevlar: TeamAppConfig = {
    title: "Kevlar",
    regularIcon: Apps28Regular,
    filledIcon: Apps28Filled,
    description: "Kevlar client application to support Service Level Network Manager(SLNM).",
    team: "Kevlar",
    publicId: "EXCHANGE\\WindowsGCP",
    owner: "kevlarwindows_oncall@microsoft.com",
    role: "*",
    tags: [],
    app: KevlarApp,
    path: "/KevlarApp"
};
